import { ValueAndLabel } from "./valueAndLabel.model";

export enum Gender {
    Female = "f",
    Male = "m"
}

export const GENDERS: ValueAndLabel[] = [
    { id: Gender.Female, text: "女性", cShipVal: "2" },
    { id: Gender.Male, text: "男性", cShipVal: "1" }
];
